import pdfMake, { userMark, setMyConfig, makeTableContent } from '../utils/pdf';

function pdfPrivados (pContent) {
  const columns = [
    {
      key: 'codigo',
      label: 'Cód.',
      width: 'auto'
    },
    'agencia:w*',
    {
      key: 'docVenta',
      label: 'Doc. Venta',
      width: 'auto'
    },
    {
      key: 'fechaLlegada',
      label: 'Fecha Llegada',
      width: 'auto'
    },
    {
      key: 'fechaSalida',
      label: 'Fecha Salida',
      width: 'auto'
    },
    {
      key: 'idioma',
      label: 'Id.',
      width: 'auto'
    },
    {
      key: 'nroAdultos',
      label: 'PAX',
      width: 16
    },
    {
      key: 'nroNinos',
      label: 'CHD',
      width: 16
    },
    {
      key: 'nroDocVenta',
      label: 'Nro. Doc. Venta',
      width: 'auto'
    },
    'pasajero:w*'
  ]

  const table = makeTableContent([...pContent.privados], columns);

  pdfMake.createPdf({
    info: {
      title: `Reporte Privados`
    },
    content: [
      {
        text: 'Reporte Privados',
        style: 'header'
      },
      {
        columns: [
          {
            text: `Agencia: ${pContent.agencia}`,
            width: 'auto'
          },
          {
            text: `Fecha Llegada: ${pContent.fechaLlegada}`,
            width: 'auto'
          },
          {
            text: `Pasajero: ${pContent.pasajero}`,
            width: 'auto'
          },
        ],
        margin: [0,0,0,5]
      },
      table,
      ...userMark(pContent.userMark, pContent.dateMark)
    ],
    ...setMyConfig()
  }).print();

  
}

export default pdfPrivados;